import { css } from "@emotion/css";

import { useTheme } from "@/modules/theme/hooks/useTheme";
import { yellow } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

import { Loader } from "./Loader";

const createLoaderStyles = ({ zIndexes, backdrops, spacing }: Theme) => {
  return {
    root: css({
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: zIndexes.backdrop,
      backgroundColor: backdrops.default,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }),
    loader: css({
      borderTopColor: yellow[600],
      borderWidth: spacing(1.5),
    }),
  };
};

export const PageLoader = () => {
  const theme = useTheme();
  const classes = createLoaderStyles(theme);

  return (
    <div className={classes.root}>
      <Loader size={theme.spacing(12)} className={classes.loader} />
    </div>
  );
};
